// Custom hook para la carga y combinacion de CEDIS con y sin protocolos de seguridad.

import { useState, useEffect, useRef } from "react"; 
import { toast } from "react-toastify";
import { useUnidades } from "./test/useUnidades";

export const useCedisProtocols = (selectedNegocioId, allNegocios) => {
    const [cedisForSelectedNegocio, setCedisForSelectedNegocio] = useState([]);
    const [isLoadingCedisProtocols, setIsLoadingCedisProtocols] = useState(true);
    const [errorCedisProtocols, setErrorCedisProtocols] = useState(null);
    const [reloadTrigger, setReloadTrigger] = useState(0);

    const { getCedisNegociosAll } = useUnidades();
    // Usa useRef para almacenar la función getCedisNegociosAll de forma estable
    const getCedisNegociosAllRef = useRef(getCedisNegociosAll);

    // Actualiza la referencia si getCedisNegociosAll cambia
    useEffect(() => {
        getCedisNegociosAllRef.current = getCedisNegociosAll;
    }, [getCedisNegociosAll]);

    useEffect(() => {
        const loadCedisAndProtocols = async () => {
            if (selectedNegocioId === null || allNegocios.length === 0) {
                setCedisForSelectedNegocio([]);
                setIsLoadingCedisProtocols(false);
                return;
            }

            setIsLoadingCedisProtocols(true);
            setErrorCedisProtocols(null);

            try{
                const currentNegocio = allNegocios.find(n => n.negocio_id === selectedNegocioId);
                const protocolsInCatCedis = currentNegocio && currentNegocio.cat_cedis ? currentNegocio.cat_cedis :[];

                // console.log ("[useCedisProtocols] Cargando todos los CEDIS para el negocio ID:", selectedNegocioId);
                // Llama a la función a través de la referencia estable
                const cedisResp = await getCedisNegociosAllRef.current(selectedNegocioId);
                // console.log("[useCedisProtocols] Respuesta de getCedisNegociosAll:", cedisResp);

                if (cedisResp.ok && cedisResp.cedis) {
                    const allCedisFromApi = cedisResp.cedis;
                    // console.log("[useCedisProtocols] Todos los Cedis del API:", allCedisFromApi);

                    const mixCedis = allCedisFromApi.map(cedisItem => {
                        const protocolInfo = protocolsInCatCedis.find(pc => pc.cedis_id === cedisItem.cedis_id); // Corregido pc.cedis_id
                        return{
                            cedis_id: cedisItem.cedis_id,
                            nombre_cedis: cedisItem.nombre_cedis,
                            protocolos_seguridad: protocolInfo ? protocolInfo.protocolos_seguridad : undefined,
                        };
                    });

                    setCedisForSelectedNegocio(mixCedis);
                    // console.log(`[useCedisProtocols] CEDIS combinados y listos para mostrar el negocio ${selectedNegocioId}`);
                } else {
                    const errorMessage = cedisResp.message || "Error al cargar los Cedis";
                    toast.error(errorMessage);
                    setErrorCedisProtocols(new Error(errorMessage));
                    setCedisForSelectedNegocio([]);
                }
            } catch (error) {
                console.error("[useCedisProtocols] Error al cargar y combinar CEDIS y protocolos:", error);
                const errorMessage = "Ocurrió un error al cargar los cedis y protocolos.";
                toast.error(errorMessage);
                setErrorCedisProtocols(new Error(errorMessage));
                setCedisForSelectedNegocio([]);
            } finally {
                setIsLoadingCedisProtocols(false);
                // console.log("[useCedisProtocols] Finalizada la carga de cedis y protocolos.");
            }
        };
        // Dependencias: getCedisNegociosAll se ha eliminado de las dependencias.
        loadCedisAndProtocols();
    }, [selectedNegocioId, allNegocios, reloadTrigger]); 

    const reloadCedisProtocols = () => {
        setReloadTrigger(prev => prev + 1);
    };
    return {
        cedisForSelectedNegocio,
        isLoadingCedisProtocols,
        errorCedisProtocols,
        reloadCedisProtocols,
    };
};